import React from "react";
import PropTypes from "prop-types";
import { Grid, Typography } from "@mui/material";

function Header({ className, ...rest }) {
  return (
    <Grid
      container
      sx={{
        width: "90%",
        margin: "20px auto 10px auto",
      }}
      className={className}
      {...rest}
    >
      <Typography
        sx={{
          fontFamily: "Roboto, sans-serif",
          fontSize: "20px",
          fontWeight: 500,
          color: "#000",
          textTransform: "uppercase",
        }}
      >
        VARIANT OPTIONS LIST
      </Typography>
    </Grid>
  );
}

Header.propTypes = {
  className: PropTypes.string,
};

export default Header;